import { Inject, Injectable, InjectionToken } from '@angular/core';

export const SL_ID_PREFIX = new InjectionToken<string>('SL_ID_PREFIX');

@Injectable()
export class SlIdContext {
  private static counters: { [prefix: string]: number } = {};
  private readonly instanceNumber: number;

  constructor(@Inject(SL_ID_PREFIX) private readonly prefix: string) {
    var current = SlIdContext.counters[prefix];
    if (current === undefined) {
      current = 0;
    }
    current++;
    SlIdContext.counters[prefix] = current;
    this.instanceNumber = current;
  }

  id(localId: string): string {
    return this.prefix + '-' + this.instanceNumber + '-' + localId;
  }
}
